import React from 'react';
import TextField from '@mui/material/TextField';
import { connect } from 'react-redux';
import setProvinceAction from '../../redux/actions/createReferenceActions/actionProvince'
import { withTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';

const StyledTextField = styled(TextField)({
  '& .MuiOutlinedInput-notchedOutline': {
    '&:hover': {
      borderColor: "rgb(0,191,255)",
    },
    '&.Mui-focused': {
      borderColor: "rgb(47, 79, 79)",
    },
  },
  '& .Mui-focused': {
    color: 'white',
  },
  width: 300,
  marginTop: 10,
  fontSize: 30,
  backgroundColor: 'rgba(19, 174, 236, 0.54)',
  fontWeight: 'bold'
});

class ProvinceForm extends React.Component {

  constructor(props) {
    super(props)

    if(this.props.selectedReferenceData && window.location.href.indexOf('/editRef') > -1){
      this.state = { province: this.props.selectedReferenceData.province, provinces: { data: [{ 'province': '' }] }};
      this.props.setProvinceFunction(this.state.province)
    } else {
      this.state = { province: '', provinces: { data: [{ 'province': '' }] }};
      this.props.setProvinceFunction('defaultProvince')
    }
  }


  shouldComponentUpdate(nextProps, nextState) {

    if (this.props.province !== nextProps.province) {
      this.setState({ province: nextProps.province}, ()=> {
        setProvinceAction(this.state.province)
      })
      return false;
    } else {
        return true;
    }
  }  
  render() {

    const { t } = this.props;
    return (
      <div>
        <div>
          <StyledTextField key={this.props.searchVal} disabled={true}  value={this.state.province} inputProps={{ maxLength: 30, style: {fontWeight: 'bold'} }} label={t('create_ref.province') + "*"} variant="outlined" error={this.props.provinceError} 
             style={{ width: 300, marginTop: 10, fontSize: 30, backgroundColor: 'rgba(19, 174, 236, 0.54)' }}/>
        </div>
      </div>
    );
  }
}

// set props to redux-store
function mapDispatchToProps(dispatch) {
  return {
    setProvinceFunction: province => {
      dispatch(setProvinceAction(province))
    }
  }
}

// get props from redux-store
function mapStateToProps(state) {
  return {
    city: state.createRefState.city,
    id: state.createRefState.id,
    provinceError: state.createRefState.provinceError,
    selectedReferenceData: state.showRefState.selectedReferenceData
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ProvinceForm));